<div class="empty-state-input">
  <input
    #searchText
    (keyup.enter)="search(searchText.value)"
    class="input-search"
    placeholder="Search"
    type="text"
  />
  <button type="button" class="next-btn" (click)="search(searchText.value)">
    Go
  </button>
</div>
